export default function map(values, func) {
  return func({...values})
}
